import { render, staticRenderFns } from "./rg-attribute.vue?vue&type=template&id=224ba146&"
import script from "./rg-attribute.vue?vue&type=script&lang=js&"
export * from "./rg-attribute.vue?vue&type=script&lang=js&"
import style0 from "./rg-attribute.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports